export default __webpack_public_path__ + "static/media/IBimageFootplantprojection1.1ddab098.png";